1
00:00:00,200 --> 00:00:01,671
[text content="What is at stake ?" style="fontSize:150px;lineHeight:120px" initial="scale(3) translate(0%, 10%)" final="scale(1) translate(0%, 0%)" duration="7s"]
What is at stake ?

2
00:00:03,271 --> 00:00:05,005
Being able to answer that very

3
00:00:05,005 --> 00:00:06,531
question is one of the most

4
00:00:06,531 --> 00:00:07,848
strategic leadership
[text remove=true]

5
00:00:07,848 --> 00:00:10,553
[image url="https://app.gerositus.com/tutorials/stakes-intro/Frame.jpg" initial="scale(1)" final="scale(1.2) translate(0%, 5%)" duration="6s"]
differentiators because it is
about framing.

6
00:00:10,553 --> 00:00:12,218
Stakes emerge from tensions

7
00:00:12,218 --> 00:00:15,131
[image url="https://app.gerositus.com/tutorials/stakes-intro/Disruption.png" initial="scale(1.3)" final="scale(1)" duration="17s"]
created by external forces or
disruptive events.

8
00:00:15,131 --> 00:00:16,934
They represent those 4 to 8 core

9
00:00:16,934 --> 00:00:18,737
elements of an organization, a

10
00:00:18,737 --> 00:00:20,679
team, or even an individual, that

11
00:00:20,679 --> 00:00:24,008
could be damaged—or lost
entirely—if nothing gets done.

12
00:00:24,008 --> 00:00:26,019
[image url="https://app.gerositus.com/tutorials/stakes-intro/BadDecision.webp" initial="scale(1)" final="scale(1.3) translate(0%, 1%)" duration="5s"]
If you don't frame correctly, then

13
00:00:26,019 --> 00:00:27,822
you will come up with a solution

14
00:00:27,822 --> 00:00:31,567
to the wrong problem, therefore
very likely the wrong decision.

15
00:00:31,567 --> 00:00:33,579
[image url="https://app.gerositus.com/tutorials/stakes-intro/Switzerland.webp" initial="scale(1.2) translate(0%, 6%)" final="scale(1) translate(0%, 0%)" duration="9s"]
Two high-profile cases—Swissair

16
00:00:33,579 --> 00:00:35,382
and Credit Suisse—illustrate

17
00:00:35,382 --> 00:00:37,046
perfectly what happens when

18
00:00:37,046 --> 00:00:40,306
leadership fails to understand
what is really at stake.

19
00:00:40,306 --> 00:00:42,248
Two companies, one disappeared,

20
00:00:42,248 --> 00:00:45,092
one is still alive, although in a
different form.

21
00:00:46,692 --> 00:00:48,440
[image url="https://app.gerositus.com/tutorials/stakes-intro/SwissAir.webp" initial="scale(1.2)" final="scale(1.2) translate(6%, -2%)" duration="10s"]
Let's take Swissair.

22
00:00:48,640 --> 00:00:50,582
The airline’s bankruptcy in 2001

23
00:00:50,582 --> 00:00:51,969
wasn’t just a financial

24
00:00:51,969 --> 00:00:54,258
failure—Authorities underestimated

25
00:00:54,258 --> 00:00:58,072
what was truly at stake, and the
consequences were irreversible.

26
00:00:58,072 --> 00:01:00,014
[image url="https://app.gerositus.com/tutorials/stakes-intro/SwissAirScandal.png" initial="scale(1.2)" final="scale(1.2) translate(-6%, 2%)" duration="17s"]
It damaged Switzerland’s global

27
00:01:00,014 --> 00:01:01,956
reputation in terms of financial

28
00:01:01,956 --> 00:01:04,382
resilience and management
credibility.

29
00:01:04,382 --> 00:01:06,117
If authorities had framed the

30
00:01:06,117 --> 00:01:09,724
problem correctly, they may have
taken different decisions.

31
00:01:09,724 --> 00:01:11,666
[image url="https://app.gerositus.com/tutorials/stakes-intro/CreditSuisse.webp" initial="scale(1.1) translate(5%, -5%)" final="scale(1) translate(0%, 0%)" duration="17s"]
In contrast with Credit Suisse in

32
00:01:11,666 --> 00:01:13,607
2023, the Swiss government acted

33
00:01:13,607 --> 00:01:17,491
decisively, recognizing that the
stakes went far beyond one bank.

34
00:01:17,491 --> 00:01:19,086
By intervening early, they

35
00:01:19,086 --> 00:01:21,028
preserved financial stability,

36
00:01:21,028 --> 00:01:23,040
saved thousands of jobs, and might

37
00:01:23,040 --> 00:01:26,785
well have created a stronger
competitive entity in the process.
[image remove=true]

38
00:01:28,185 --> 00:01:31,583
[image url="https://app.gerositus.com/tutorials/stakes-intro/NGO.jpg" initial="scale(1.2)" final="scale(1) translate(0%, 2%)" duration="17s"]
Let's now take the example of this
Swiss humanitarian NGO.

39
00:01:31,583 --> 00:01:34,843
One trend and 2 events happened
almost simultaneously:

40
00:01:36,243 --> 00:01:38,185
An increasing "fatigue" of Swiss
[image url="https://app.gerositus.com/tutorials/stakes-intro/NGOFatigue.webp" initial="scale(1.2)" final="scale(1)" duration="17s"]

41
00:01:38,185 --> 00:01:41,999
population who's solicited by
hundreds of associations and NGOs

42
00:01:43,399 --> 00:01:45,064
[image url="https://app.gerositus.com/tutorials/stakes-intro/CEO.png" initial="scale(1.2)" final="scale(1)" duration="20s"]
The publication, from Swiss

43
00:01:45,064 --> 00:01:47,144
investigational journalists, of a

44
00:01:47,144 --> 00:01:49,988
list of NGO's with the respective
CEOs salaries.

45
00:01:49,988 --> 00:01:51,652
Whilst some were absolutely

46
00:01:51,652 --> 00:01:53,178
reasonable, some could be

47
00:01:53,178 --> 00:01:55,189
considered as outrageous from the

48
00:01:55,189 --> 00:01:59,212
very public who is giving its own
money to support humanitarian cause

49
00:02:00,612 --> 00:02:03,178
The suspension of US
contributions to USAID
[image url="https://app.gerositus.com/tutorials/stakes-intro/USAID.jpg" initial="scale(1)" final="scale(1.4)" duration="17s" delay=2000]

50
00:02:04,778 --> 00:02:06,249
What is at stake?
[image remove=true]
[unmask target="main"]

51
00:02:07,849 --> 00:02:09,810
[createIndicator id="trust" name="Multi-dimensional trust" trend="50" delay=500]
Multi-dimensional trust (with

52
00:02:09,810 --> 00:02:13,804
individual donors particularly,
with staff, governments etc.)

53
00:02:14,004 --> 00:02:15,811
[createIndicator id="revenues" name="Revenues for the year" trend="50" delay=1000]
Revenues for the year

54
00:02:16,211 --> 00:02:18,163
[createIndicator id="invest" name="Investments in the year" trend="50" delay=500]
Investments in the year

55
00:02:18,563 --> 00:02:20,153
[createIndicator id="field" name="Field operations" trend="50" delay=200]
Field operations

56
00:02:21,753 --> 00:02:23,568
With this framing in mind, the

57
00:02:23,568 --> 00:02:25,601
Board and management team of that

58
00:02:25,601 --> 00:02:27,272
NGO have a clear view of what

59
00:02:27,272 --> 00:02:28,869
needs to be done, probably

60
00:02:28,869 --> 00:02:30,757
headcount freeze, scrutiny on

61
00:02:30,757 --> 00:02:32,718
spending, drastic review of the

62
00:02:32,718 --> 00:02:35,260
investments and projects
portfolio etc.

63
00:02:36,660 --> 00:02:40,218
Please note the meter with the bar
on the side of each stake.

64
00:02:40,218 --> 00:02:41,816
[updateIndicator id="trust" trend="33"]
It allows you to assess the

65
00:02:41,816 --> 00:02:43,776
current situation and if you use

66
00:02:43,776 --> 00:02:45,519
[updateIndicator id="invest" trend="66"]
scenarios for simulation or

67
00:02:45,519 --> 00:02:48,061
update, you can see how
the stake evolves.

68
00:02:49,461 --> 00:02:53,092
I thank you very much for your
attention, and happy framing!

